module.exports = __webpack_public_path__ + "img/root1.48d7d1c5.png";